<template lang="pug">
  #app.font-unica.leading-lg.trans-bg-quick(:class="['bg-app-bg']")
    //- header
    app-header(:isLib="isLib")
    //- main
    .min-h-screen.overflow-x-hidden-off
      transition(:name="transition", @after-leave="afterLeave", @after-enter="afterEnter")
        router-view(:key="rtKey")
    //- footer
    app-footer
    //- subscribe
    transition(name="fade")
      subscribe.fixed.z-50(v-show="subscribe")
    //- banners
    banners
</template>

<script>
import '@/style/_main.css'
import AppHeader from '@/components/AppHeader'
import AppFooter from '@/components/AppFooter'
import Subscribe from '@/components/Subscribe'
import Banners from '@/components/Banners/Banners'
import { mapState } from 'vuex'
import _throttle from 'lodash/throttle'
export default {
  name: 'App',
  computed: {
    ...mapState(['subscribe', 'bus', 'transition', 'scrollLocked']),
    isLib () {
      return this.$route.path.indexOf('/library') === 0
    },
    rtKey () {
      const rt = this.$route
      return !rt.name ? rt.path
        : rt.name.includes('product') ? 'products' // all hostem sections
          : rt.name.includes('blue-projecs') ? rt.params.slug
            : rt.path
    }
  },
  methods: {
    onResize: _throttle(function () {
      const update = (value, old, emit, commit) => {
        if (value === old) return
        this.$store.commit(commit, value)
        this.bus.$emit(emit)
      }
      update(window.innerWidth, this.winW, 'newWindowWidth', 'SET_WIN_W')
      update(window.innerHeight, this.winH, 'newWindowHeight', 'SET_WIN_H')
    }, 100),
    afterLeave () {
      this.$root.$emit('triggerScroll')
    },
    afterEnter () {
      this.$store.commit('SET_PAGE_TRANSITION')
    },
    setTheme (theme) {
      document.documentElement.style.setProperty('--app-text', theme.text)
      document.documentElement.style.setProperty('--app-bg', theme.bg)
      document.documentElement.style.setProperty('--app-accent', theme.accent)
    },
    defaultTheme () {
      let options = {
        text: this.$store.state.site.color_text,
        bg: this.$store.state.site.color_bg,
        accent: this.$store.state.site.color_accent
      }
      this.setTheme(options)
    }
  },

  // lifecycle
  created () {
    this.$store.dispatch('getGlobals')
    this.$store.dispatch('shop/fetchCheckout')
    this.$store.dispatch('shop/getCountries')
    this.$store.dispatch('shop/getUserCountry')
    this.$store.commit('SET_SUBSCRIBE', this.$route.query.subscribe)
  },
  mounted () {
    window.addEventListener('resize', this.onResize)
  },
  watch: {
    scrollLocked (lock) {
      // un/lock scroll via body overflow (browsers keep scroll position :)
      document.body.style.overflow = lock ? 'hidden' : ''
    },
    '$store.state.site': function () {
      // on site load, set bg colors (once)
      this.$store.commit('CHANGE_THEME')
    },
    '$store.state.changeTheme': function () {
      // triggers on first load, and after page nav

      // Set default colors
      this.defaultTheme()

      if (!this.$store.state.site) {
        return
      }

      let path = window.location.pathname
      let query = window.location.search
      let match = false

      console.log('p', path, 'q', query)

      this.$store.state.site.color_theme.forEach(theme => {
        theme.pages.forEach(page => {
          // If page is draft

          if (page.post_status === 'draft') {
            if (query) {
              if (query.includes(page.ID)) {
                match = true
              }
            }
          } else {
            let p = path.split('/')

            // Get end slug from url
            if (p.pop() === '') {
              p = p[p.length - 2]
            } else {
              p = p.pop()
            }

            console.log('p', p, 'id', page.post_name)

            if (p === page.post_name) {
              match = true
            }
          }

          if (match === true) {
            let options = {}
            options.text = theme.color_text
            options.bg = theme.color_bg
            options.accent = theme.color_accent
            this.setTheme(options)
            match = false
            return false
          }
        })
      })
    }
  },

  components: { AppHeader, AppFooter, Subscribe, Banners },
  metaInfo: {
    titleTemplate (chunk) {
      return chunk ? `${chunk} – Blue Mountain School` : 'Blue Mountain School'
    }
  }
}
</script>

<style>
*{
  -webkit-tap-highlight-color: rgba(0,0,0,0);
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
